import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { publicApi, ApiRequestError } from '@api/client';

type State = 'loading' | 'success' | 'already_confirmed' | 'invalid' | 'error';

export function CustomerConfirm() {
  const { confirmationToken } = useParams<{ confirmationToken: string }>();
  const [state, setState] = useState<State>('loading');

  useEffect(() => {
    if (!confirmationToken) {
      setState('invalid');
      return;
    }
    publicApi
      .confirmBooking(confirmationToken)
      .then(() => { setState('success'); })
      .catch((err: unknown) => {
        if (err instanceof ApiRequestError) {
          if (err.status === 404) { setState('invalid'); return; }
          if (err.status === 409 || err.code === 'INVALID_STATUS_TRANSITION') {
            setState('already_confirmed');
            return;
          }
        }
        setState('error');
      });
  }, [confirmationToken]);

  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <div className="max-w-sm w-full text-center space-y-4">
        {state === 'loading' && (
          <p className="text-muted-foreground">Confirmando tu cita…</p>
        )}

        {state === 'success' && (
          <>
            <div className="text-5xl">✓</div>
            <h1 className="text-2xl font-bold text-green-600">¡Cita confirmada!</h1>
            <p className="text-muted-foreground">
              Tu cita ha sido confirmada correctamente. Recibirás un email de confirmación.
            </p>
          </>
        )}

        {state === 'already_confirmed' && (
          <>
            <div className="text-5xl">ℹ</div>
            <h1 className="text-2xl font-bold">Ya confirmada</h1>
            <p className="text-muted-foreground">
              Esta cita ya estaba confirmada anteriormente.
            </p>
          </>
        )}

        {state === 'invalid' && (
          <>
            <div className="text-5xl">✗</div>
            <h1 className="text-2xl font-bold text-destructive">Enlace inválido</h1>
            <p className="text-muted-foreground">
              El enlace de confirmación no es válido o ha expirado.
            </p>
          </>
        )}

        {state === 'error' && (
          <>
            <div className="text-5xl">⚠</div>
            <h1 className="text-2xl font-bold text-destructive">Error</h1>
            <p className="text-muted-foreground">
              Ha ocurrido un error. Por favor, inténtalo de nuevo más tarde.
            </p>
          </>
        )}

        {(state === 'success' || state === 'already_confirmed') && (
          <p className="text-sm text-muted-foreground">
            ¿Quieres ver o gestionar tu cita?{' '}
            <Link to="/" className="underline">
              Ir al inicio
            </Link>
          </p>
        )}
      </div>
    </main>
  );
}
